export default "__VITE_ASSET__BZXUWHfp__"